import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class AuditLogsService {
    // Use Laravel basePath (same as other API calls)
    private basePath = environment.interop.basePath;
    private logsBasePath = environment.interop.indoc.nomenclatoare.administrative.signer;

    constructor(private http: HttpClient) {}

    getAuditLogs(params: any): Observable<any> {
        const url = `${this.basePath}${this.logsBasePath.logs?.audit || 'api/registratura/signer/logs/audit'}`;
        return this.http.get<any>(url, {
            params: this.buildParams(params)
        });
    }

    getAuditLogDetail(logId: number): Observable<any> {
        const detailPath = this.logsBasePath.logs?.auditDetail || 'api/registratura/signer/logs/audit/';
        const url = `${this.basePath}${detailPath}${logId}`;
        return this.http.get<any>(url);
    }

    getActions(): Observable<any> {
        const url = `${this.basePath}${this.logsBasePath.logs?.auditActions || 'api/registratura/signer/logs/meta/actions'}`;
        return this.http.get<any>(url);
    }

    exportCsv(params: any): Observable<Blob> {
        const url = `${this.basePath}${this.logsBasePath.logs?.auditExport || 'api/registratura/signer/logs/audit/export/csv'}`;
        return this.http.get(url, {
            params: this.buildParams(params),
            responseType: 'blob'
        });
    }

    private buildParams(params: any): HttpParams {
        let httpParams = new HttpParams();
        Object.keys(params).forEach(key => {
            if (params[key] !== null && params[key] !== undefined && params[key] !== '') {
                httpParams = httpParams.set(key, params[key]);
            }
        });
        return httpParams;
    }
}
